import React from 'react';
import { Link } from 'react-router-dom';

export default function BeforeAfterCard({
  beforeImage = 'linear-gradient(135deg, #5a4d3f, #2a221b)',
  afterImage = 'linear-gradient(135deg, #d4b88a, #a98a5f)',
  beforeLabel = 'Πριν',
  afterLabel = 'Μετά',
  service,
  title,
  description,
  href,
  className = '',
}) {
  const content = (
    <>
      <div className="grid grid-cols-2 aspect-[16/10]">
        <div
          className="relative flex items-end justify-start p-4"
          style={{ background: beforeImage }}
        >
          <span className="bg-warm-black/80 text-cream px-3 py-1 rounded-pill text-tiny font-medium tracking-wider uppercase">
            {beforeLabel}
          </span>
        </div>
        <div
          className="relative flex items-end justify-start p-4"
          style={{ background: afterImage }}
        >
          <span className="bg-gold text-warm-black px-3 py-1 rounded-pill text-tiny font-semibold tracking-wider uppercase">
            {afterLabel}
          </span>
        </div>
      </div>

      <div className="p-6">
        {service && (
          <div className="text-eyebrow uppercase text-gold tracking-wider mb-2 font-medium">
            {service}
          </div>
        )}
        {title && (
          <h3 className="font-serif text-[22px] text-warm-black mb-2 font-medium leading-[1.2]">
            {title}
          </h3>
        )}
        {description && (
          <p className="text-[14px] text-muted leading-[1.5]">
            {description}
          </p>
        )}
      </div>
    </>
  );

  const baseClass = `group block rounded-card-l overflow-hidden bg-ivory transition-all duration-500 hover:-translate-y-2 hover:shadow-card ${className}`;

  if (href) {
    return (
      <Link to={href} className={baseClass}>
        {content}
      </Link>
    );
  }

  return <div className={baseClass}>{content}</div>;
}